import Vue from 'vue/dist/vue.min.js';
import isotope from 'vueisotope';
import coverModes from '../modules/cover-modes';


/**
 * @file Handles filtering of categories on sportevents page
 * @author michael.schmid@notch-interactive.com
 *
 * @module modules/m12-category-selector
 *
 **/

const instance = {},

    /**
     *
     * @typedef defaults
     */

    defaults = {
        filterClickContainer: '.sidebarnav',
        filter: '[data-filter]',
        isActiveClass: 'is-active',
        vueEl: '.m-category-selector',
        mediumMediaQuery: '(min-width: 33.75em)',
        xxLargeMediaQuery: '(min-width: 87.5em)'
    };

let settings,
    filterClickContainer,
    vueEl,
    categorySelectorVm,
    filters,
    filterData = {
        'show all': function () {
            return true;
        }
    },

    setFilterActive = (currentTarget) => {

        // Remove all current active states
        filters.forEach((filter) => {
            filter.classList.remove(settings.isActiveClass);
        });

        currentTarget.classList.add(settings.isActiveClass);
    },

    initFilterData = () => {
        const uniqueDisciplines = [];
        DS.translations.categories.forEach((category) => {
            category.discipline.forEach((discipline) => {

                // Get all unique disciplines
                if (uniqueDisciplines.indexOf(discipline) === -1) {
                    uniqueDisciplines.push(discipline);
                }
            });
        });

        // Build new filterData object in order to make filtering dynamic (only depending on the DS data)
        uniqueDisciplines.forEach((discipline) => {
            filterData[discipline] = new Function('el', 'return el.discipline.indexOf(\'' + discipline + '\') > -1;');
        });
    };

let initVue = () => {

    Vue.component('isotope', isotope);

    categorySelectorVm = new Vue({
        el: settings.vueEl,
        delimiters: ['[[', ']]'],
        data: {
            list: window.DS.translations.categories,
            mediumMediaQuery: settings.mediumMediaQuery,
            xxLargeMediaQuery: settings.xxLargeMediaQuery,
            layouts: [
                'masonry',
                'vertical'
            ],
            filterOption: 'show all',
            option: {
                itemSelector: '.item',
                getFilterData: filterData
            }
        },
        methods: {
            filter (key) {
                this.$refs.cpt.filter(key);
            },
            filterChange(value) {
                this.filterOption = value;
            },
            arranged() {
                coverModes.refresh();
            },
            cons(key) {
                console.log('key: ', key);
            },
            concatenateSrcString(breakpoint, srcSmall, srcLarge) {

                if (breakpoint === 'small') {
                    return srcSmall + ' 1x, ' + srcLarge + ' 2x';

                } else if (breakpoint === 'medium') {
                    return srcSmall + ' 1x, ' + srcLarge + ' 1.5x';

                } else if (breakpoint === 'xxlarge') {
                    return srcSmall + ' 1x';
                }
            }
        }
    });
};

let bindEvents = () => {
    filterClickContainer.addEventListener('click', (e) => {
        const currentTarget = e.target;

        if (currentTarget.hasAttribute('data-filter')) {
            let categoryFilter = e.target.dataset.filter;
            categorySelectorVm.filter(categoryFilter);
            setFilterActive(currentTarget);
        }
    });
};

/**
 * Initialize module
 *
 * @param {object} options - Override default settings with options object.
 * @return {object} Instance of created module.
 */

instance.init = (options) => {
    settings = Object.assign({}, defaults, options);

    filterClickContainer = document.querySelector(settings.filterClickContainer);
    vueEl = document.querySelector(settings.vueEl);
    filters = [...document.querySelectorAll(settings.filter)];

    initFilterData();

    if (vueEl !== null) {
        bindEvents();
        initVue();
    }
};

export default instance;
